import { showSuccessToast } from "@/services";
import { openSpaceLinksAPI } from "./api";

export const getOpenSpaceLinks = async (filters) => {
  try {
    const res = await openSpaceLinksAPI.getList(filters);
    return res?.data;
  } catch (e) {}
};
export const addOpenSpaceLink = async (body, params = {}) => {
  try {
    const res = await openSpaceLinksAPI.addLink(body, params);
    return res?.floor_map;
  } catch (e) {}
};
export const deleteFloorMapLink = async (
  floor_map_id,
  openspace_id,
  params
) => {
  try {
    const res = await openSpaceLinksAPI.deleteFloorMapLink(
      floor_map_id,
      openspace_id,
      params
    );
    return { data: res?.floor_map, openspace: res?.openspace };
  } catch (e) {}
};

export const getFloorMapLinks = async (floor_map_id, params) => {
  try {
    const res = await openSpaceLinksAPI.getFloorMapLinks({
      floor_map_id,
      params,
    });
    return res?.data;
  } catch (e) {}
};

export const openSpaceLinksColumns = [
  {
    name: "resident_name",
    label: "ЖК",
    align: "left",
  },
  {
    name: "entrance",
    label: "Подъезд",
    align: "center",
  },
  {
    name: "block_name",
    label: "Блок",
    align: "center",
  },
  {
    name: "floor",
    label: "Этаж",
    align: "center",
  },
  {
    name: "links",
    label: "",
    align: "center",
  },
];
export const linksColumns = [
  {
    name: "id",
    label: "#",
    align: "center",
  },
  {
    name: "link",
    label: "Ссылка",
    align: "left",
  },
  {
    name: "date",
    label: "Дата съемки",
    align: "center",
  },
  {
    name: "actions",
    label: "",
    align: "center",
  },
];
export const copyText = (text = "") => {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard
      .writeText(text)
      .then(() => showSuccessToast("Скопировано!"))
      .catch(() => {});
  } else {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.style.position = "fixed";
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();

    try {
      document.execCommand("copy");
      showSuccessToast("Скопировано!");
    } catch (err) {}

    document.body.removeChild(textarea);
  }
};
